import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import ButtonRounded from "../../../../components/ButtonRounded";
import RequiredAsterisk from "../../../../components/texts/RequiredAsterisk";
import ModalContainer from "../../../../components/ModalContainer";
import KeyboardDatePicker from "../../../../components/inputs/KeyboardDatePicker";
import moment from "moment";
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import {postBiotemplateReconciliation} from "../../../../api/sustainability/storage/reconciliation/postBiotemplateReconciliation";
import {useModalSaveTransferStyles} from "../../../../common/styles/modalStyles";

const useStyles = useModalSaveTransferStyles;

interface ModalSaveReconciliationProps {
  open: boolean;
  onClose: () => void;
  data: any;
  generalData: {
    volume: any;
    reconcile_volume: any;
    biofuel_type: any;
    storage_terminal: any;
    status: any;
  };
}

const ModalSaveReconciliation: React.FC<ModalSaveReconciliationProps> = ({
  open,
  onClose,
  data,
  generalData,
}) => {
  const [formData, setFormData] = useState<any[]>([]);
  const [comment, setComment] = useState<string>("");
  const [reconciliationDate, setReconciliationDate] = useState<string>("");
  const [showSaveModal, setShowSaveModal] = useState<boolean>(false);
  const classes = useStyles();
  const history = useHistory();

  const hasData: boolean = Array.isArray(data) && data.length > 0;

  const isError: boolean = !reconciliationDate || !comment || comment.length < 1;

  const [successModalOpen, setSuccessModalOpen] = useState(false);
  const handleCloseSuccessModal = () => setSuccessModalOpen(false);
  const handleRedirect = () => {
    setSuccessModalOpen(false);
    history.goBack();
  };

  const handleDataSubmit = async () => {
    const res = await postBiotemplateReconciliation({
      volume: generalData.reconcile_volume,
      storage_terminal: generalData.storage_terminal,
      biofuel_type: generalData.biofuel_type,
      status: generalData.status,
      comment,
      reconcile_date: reconciliationDate,
      biotemplates: data
    });

    if (res) {
      setSuccessModalOpen(true);
    } else {
      alert("Some error occured");
    }
  };

  const handleDateChange = (date: MaterialUiPickersDate | null) => {
    if (date) {
      const formattedDate = moment(date).format("YYYY-MM-DD");
      setReconciliationDate(formattedDate);
    } else {
      setReconciliationDate("");
    }
  };

  const closeSaveModal = () => {
    setShowSaveModal(false);
  };

  useEffect(() => {
    formData.push(
      {
        reconciliation_date: new Date(),
        comment: "",
      }
    );
  }, [generalData]);

  // @ts-ignore
  return (
    <ModalContainer
      open={open}
      onClose={onClose}
      title="Save Transaction"
      maxWidth="xs"
    >
      <div className={classes.modalContent}>
        <Typography variant="body1" paragraph className={classes.noteText}>
          Note: Saving this transaction will reset your allocation (reporting
          and simulation)
        </Typography>
        <Typography variant="body1" paragraph>
          To save the transaction, leave a comment describing what changes were
          made and why.
        </Typography>
        <Typography variant="body1" className={classes.commentTitle}>
          Reconcilication Date <RequiredAsterisk />
        </Typography>
        <KeyboardDatePicker
            className={classes.marginBottom}
            value={reconciliationDate ? reconciliationDate : null}
            placeholder={moment(new Date()).format("YYYY-MM-DD")}
            name="reconciliation_date"
            onChange={handleDateChange}
            inputVariant="outlined"
            format="YYYY-MM-DD"
            invalidDateMessage="Invalid Date"
        />

        <Typography variant="body1" className={classes.commentTitle}>
          Comment <RequiredAsterisk />
        </Typography>

        <TextField
            className={classes.marginBottom}
            variant="outlined"
            name="comment"
            placeholder="Write a comment"
            multiline
            fullWidth
            rows={4}
            value={comment}
            onChange={e => setComment(e.target.value)}
        />

        <Grid container className={classes.btnContainer} spacing={2}>
          <Grid item xs>
            <ButtonRounded
                fullWidth
                variant="outlined"
                color="default"
                onClick={onClose}
            >
              Cancel
            </ButtonRounded>
          </Grid>
          <Grid item xs>
            <ButtonRounded
                fullWidth
                variant="contained"
                color="primary"
                disabled={isError}
                onClick={handleDataSubmit}
            >
              Save
            </ButtonRounded>
          </Grid>
        </Grid>

        {successModalOpen && (
            <ModalContainer
                open={successModalOpen}
                onClose={handleCloseSuccessModal}
                title="Saved Successfully"
                maxWidth="xs"
            >
              <div
                  style={{
                    textAlign: "center",
                    padding: "16px",
                  }}
              >
                <Typography variant="body1" gutterBottom>
                  Your changes have been saved successfully!
                </Typography>
                <Grid
                    container
                    spacing={2}
                    alignContent={"center"}
                    alignItems={"center"}
                    justify={"center"}
                >
                  <Grid item>
                    <br></br>
                    <ButtonRounded
                        variant="outlined"
                        color="default"
                        onClick={handleRedirect}
                    >
                      Redirect to Previous Page
                    </ButtonRounded>
                  </Grid>
                </Grid>
              </div>
            </ModalContainer>
        )}

        {isError && (
          <Typography
            align="center"
            variant="body2"
            color="error"
            className={classes.errorMsg}>
            Please Filled all required field.
          </Typography>
        )}

        {!hasData && (
          <Typography
            align="center"
            variant="body2"
            color="error"
            className={classes.errorMsg}
          >
            Allocated quantity in the table can not be blank.
          </Typography>
        )}
      </div>
    </ModalContainer>
  );
};

export default ModalSaveReconciliation;
